import {isDefined} from "@/utils";
import {LocalStorageHelper} from '@/localStorageHelper';

export const supportedLanguages = ['de', 'en'];

export default {

  getCurrentLang() {

    let lang = LocalStorageHelper.getLang();
    if (isDefined(lang)) {
      return lang;
    }
    const html = document.getElementsByTagName("html");
    if (html && html.length > 0) {
      lang = html[0].getAttribute("lang");
    }

    if (isDefined(lang) && supportedLanguages.findIndex(l => l === lang) > -1) {
      return lang;
    }

    const url = window.location.href;
    if (url.includes('/de/')) {
      return 'de'
    } else {
      return 'en'
    }
  }

}
